/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         12/04/24
 * Module name:  mkad-licenses
 * File name:    mkad-licenses.service.ts
 * IDE:          WebStorm
 */

import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {
  LicensesContactParamsInterface,
  LicensesFeatureContactCountInterface,
  LicensesFeatureUserCountInterface,
  LicenseSummaryInterface,
  LicensesUserAvailableInterface,
  LicensesUserParamsInterface,
} from '../../../interface';
import {Observable} from 'rxjs';

@Injectable()
export class MkadLicensesService extends MkadBaseService {
  private readonly licenses = URLS_SERVICE.meerkad.licenses;
  private readonly customer = URLS_SERVICE.meerkad.customer;

  summary(): Observable<LicenseSummaryInterface[] | null> {
    return this.http.post<LicenseSummaryInterface[] | null>(this.customer.base + this.licenses.base + this.licenses.summary);
  }

  customerUser(params: LicensesUserParamsInterface): Observable<LicensesUserAvailableInterface> {
    return this.http.post<LicensesUserAvailableInterface>(this.customer.base + this.licenses.base + this.customer.base + this.licenses.customerUser, params);
  }

  featureUser(params: LicensesUserParamsInterface): Observable<LicensesFeatureUserCountInterface> {
    return this.http.post<LicensesFeatureUserCountInterface>(this.customer.base + this.licenses.base + this.licenses.customerUser, params);
  }

  customerDevice(params: LicensesUserParamsInterface): Observable<LicensesUserAvailableInterface> {
    return this.http.post<LicensesUserAvailableInterface>(this.customer.base + this.licenses.base + this.customer.base + this.licenses.customerDevice, params);
  }

  licenseByContract(payload: LicensesContactParamsInterface): Observable<LicensesFeatureContactCountInterface> {
    return this.http.post<LicensesFeatureContactCountInterface>(this.customer.base + this.licenses.base + this.licenses.licenseByContract, payload);
  }

}
